/** Место подстановки в тексте результата: подставленное значение и границы места в тексте. */
export type ChartTemplatePlace = {
  /** Имя значения выборки, подставленного в это место */
  name: string;
  start: number;
  end: number;
};

/** Место подстановки — имя значения выборки в фигурных скобках. */
const TEMPLATE_PLACE_PATTERN = /\{([^{}]*)\}/g;

/** Места подстановки текста результата — в том порядке, в каком они идут в тексте. */
export const chartTemplatePlaces = (template: string): ChartTemplatePlace[] =>
  [...template.matchAll(TEMPLATE_PLACE_PATTERN)].map((match) => ({
    name: match[1],
    start: match.index ?? 0,
    end: (match.index ?? 0) + match[0].length,
  }));

/** Текст результата с местом подстановки, заменённым на другое значение выборки. */
export const withPlaceValue = (template: string, place: ChartTemplatePlace, name: string): string =>
  `${template.slice(0, place.start)}{${name}}${template.slice(place.end)}`;

/** Текст результата с новым местом подстановки, вставленным в заданную позицию. */
export const withInsertedPlace = (template: string, at: number, name: string): string =>
  `${template.slice(0, at)}{${name}}${template.slice(at)}`;
